export default "__VITE_PUBLIC_ASSET__702eb7b5__"